// 不同功能模块的路由应代码分离
import userAgreement from '../components/home.vue';
import invoice from '../components/invoice/index.vue'
import signIn from './signIn';
import mine from './mine';
import cate from './cate';
import homePage from './homePage';
import help from './help';
import download from './download';
import delicacy from './delicacy'
import uniteWork from './uniteWork';
import events from './events'


export default [{
        path: '/',
        meta: {
            title: "首页导航"
        },
        component: userAgreement,
    }, {
        path: '/invoice',
        meta: {
            title: '发票说明'
        },
        component: invoice
    },
    ...signIn,
    ...mine,
    ...cate,
    ...homePage,
    ...download,
    ...help,
    ...delicacy,
    ...uniteWork,
    ...events
]
